import { COMMON, type CommonProps } from '#app/theme/constants.js';
import { sx, type SXProps } from '#app/theme/utils.js';
import { css, styled } from 'styled-components';

type StyledTextFieldMenuProps = CommonProps &
  SXProps & {
    dropdownPosition?: 'bottom' | 'top';
  };

export const StyledTextFieldMenu = styled.div<StyledTextFieldMenuProps>`
  ${({ dropdownPosition = 'bottom', theme }) => css`
    position: absolute;
    ${dropdownPosition === 'bottom'
      ? `top: calc(100% + 2px);`
      : `bottom: calc(100% + -180px);`}
    ${dropdownPosition === 'bottom' ? 'left: 0;' : 'right: 0;'}
    z-index: ${theme.zIndices.menu};
    width: 100%;
    ${COMMON}
    ${sx}
  `}
`;

StyledTextFieldMenu.displayName = 'TextField.Menu';
